var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12 p-20" },
    [
      _c(
        "div",
        {
          staticClass:
            "heading separator d-flex align-items-center xs-flex-start pr-8 mb-15 xs-flex-column justify-space-between",
        },
        [
          _c(
            "div",
            { staticClass: "d-flex col-gap-15 align-items-center flex-70" },
            [
              _c("img", {
                staticClass: "cursor-pointer",
                attrs: { src: "static/images/icons/chevron_left.svg" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              }),
              _c("span", { staticClass: "word-break text-emergo-dark-blue" }, [
                _vm._v(
                  _vm._s(_vm.searchResponse.total_search_result_count) +
                    " Result(s) for ‘" +
                    _vm._s(_vm.searchTerm) +
                    "’ in " +
                    _vm._s(_vm.serviceName) +
                    " "
                ),
              ]),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "emergo-white-button xs-flex-100",
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("Exit Search")]
          ),
        ]
      ),
      _c("div", { staticClass: "col-lg-12 p-0" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 p-0 position-relative filter-wrapper" },
          [
            _c("shared-left-filter", {
              attrs: {
                chevronList: _vm.chevronList,
                expectedFilter: _vm.resultingFilter,
                categoriesList: _vm.categoriesList,
                countriesList: _vm.countryListFilter,
                types: _vm.types,
                isCountryString: true,
              },
              on: { setFilter: _vm.filteredOptions },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 p-0 list-wrapper" },
          [
            _vm.subCategoryResults[0]
              ? _vm._l(
                  _vm.subCategoryResults[0].service_results,
                  function (service, index) {
                    return _c(
                      "div",
                      { key: index + 0, staticClass: "col-xs-12 p-0" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "card cursor-pointer",
                            on: {
                              click: function ($event) {
                                return _vm.navigateToRespectivePage(service)
                              },
                            },
                          },
                          [
                            _c("services", {
                              attrs: {
                                serviceName: _vm.serviceName,
                                recordInfo: service,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "pagination-wrapper col-xs-12 p-0" },
        [
          _vm.total
            ? _c("pagination", {
                attrs: {
                  totalPages: _vm.totalPages,
                  maxVisibleButtons: _vm.maxVisiblePages,
                  total: _vm.total,
                  perPage: _vm.perPage,
                  currentPage: _vm.currentPage,
                },
                on: { pagechanged: _vm.pagechanged },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("unsubscribed-country-popup", {
        attrs: {
          id: "modal_unsubscribed_market",
          isGlobalSearch: true,
          selectedServiceId: _vm.selectedServiceId,
        },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }